import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=9cc1d9e0"
import script from "./Editor.vue?vue&type=script&setup=true&lang=js"
export * from "./Editor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Editor.vue?vue&type=style&index=0&id=9cc1d9e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports